export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}
export const getStore = name => {
  if (!name) return;
  let content = window.localStorage.getItem(name);
  if (!content || content === 'undefined' || content === 'null') {
    return "";
  }
  return content;
}

export function clearStorage(name) {
  if (!name) return;
  return window.localStorage.removeItem(name)
}

export function clearStorageAll() {
  return window.localStorage.clear()
}



// WEBPACK FOOTER //
// ./src/utils/storage.js